import { createElement } from 'react';

import { Link } from 'react-router';

import { HEADING_CONST, type HeadingProps } from './Heading.d';
import { Heading, ButtonShowAll } from './Heading.styles';

const HeadingBase = ({
  as = 2,
  children,
  color,
  level,
  textAlign = 'left',
  link,
  trackClick,
  ...props
}: HeadingProps) => (
  <Heading data-testid={HEADING_CONST.TEST_ID} data-has-link={!!link}>
    {createElement(
      `h${as}`,
      {
        'data-color': color,
        'data-level': level,
        'data-text-align': textAlign,
        ...props,
      },
      children,
    )}
    {link && (
      <Link to={link}>
        <ButtonShowAll onClick={() => trackClick?.()}>Ver tudo</ButtonShowAll>
      </Link>
    )}
  </Heading>
);

export default HeadingBase;
